import React, { useState, useEffect } from "react";
import SurfaceCard from "../../../../components/Common/SurfaceCard";
import { Button, FormControl, TextField, Typography } from "@mui/material";
import { FormContentBox } from "./styled";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../../context/AuthContext";
import useAdministrationService from "../../../../services/administration/useAdministrationService";
import useToast, { ToastType } from "../../../../hooks/useToast";

function GeneralDetails() {
    const { t } = useTranslation("common");
    const { activeLocation, activeLocationId, updateLocationDetails } = useAuth();
    const { updateGeneralDetails } = useAdministrationService();
    const { showToast } = useToast();
    
    const [name, setName] = useState("");
    const [address, setAddress] = useState("");
    const [numStations, setNumStations] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (activeLocation) {
            setName(activeLocation.name);
            setAddress(activeLocation.address);
            setNumStations(activeLocation.numstations ?? 0);
        }
    }, [activeLocation]);
    
    const handleSave = async () => {
        try {
            setIsLoading(true);
            await updateGeneralDetails({
                locationName: name,
                locationAddress: address,
                numStations,
            });

            // Update the location details in the auth context
            if (activeLocationId) {
                updateLocationDetails(activeLocationId, name, address, numStations);
            }
            
            showToast({
                message: t("administration.locationAdministration.generalInformation.updatedSuccessfully"),
                type: ToastType.SUCCESS,
            });
        } catch (error) {
            showToast({
                message: t("common.unknownError"),
                type: ToastType.ERROR,
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <SurfaceCard
            title={
                <Typography variant="h4">
                    {t("administration.locationAdministration.generalInformation")}
                </Typography>
            }
            contentSx={{ gap: 4 }}
        >
            <FormContentBox>
                <FormControl fullWidth sx={{ gap: 3 }}>
                    <TextField
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        label={t("administration.locationAdministration.locationName")}
                        variant="outlined"
                        fullWidth
                        disabled={isLoading}
                    />
                    <TextField
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        label={t("administration.locationAdministration.address")}
                        variant="outlined"
                        fullWidth
                        disabled={isLoading}
                    />
                    <TextField
                        value={numStations}
                        onChange={(e) => setNumStations(Math.max(1, parseInt(e.target.value) || 1))}
                        label={t("administration.locationAdministration.numStations")}
                        variant="outlined"
                        type="number"
                        slotProps={{ htmlInput: { min: 1 } }}
                        fullWidth
                        disabled={isLoading}
                    />
                </FormControl>
                <Button 
                    variant="outlined" 
                    color="primary" 
                    sx={{ alignSelf: 'flex-end' }}
                    onClick={handleSave}
                    disabled={isLoading}
                >
                    {t("common.save")}
                </Button>
            </FormContentBox>
        </SurfaceCard>
    );
}

export default GeneralDetails;
